module.exports = __webpack_public_path__ + "static/img/envelope.466d089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/envelope.png
// module id = 2sEM
// module chunks = 1 3